// @ts-nocheck
/* eslint-disable */
import { Coin, CoinAmino } from "../../cosmos/base/v1beta1/coin";
import { Timestamp } from "../../google/protobuf/timestamp";
import { BinaryReader, BinaryWriter } from "../../deps/binary";
import { DeepPartial, Exact } from "../../deps/helpers";
export const protobufPackage = "OmniFlix.medianode.v1beta1";
export enum Status {
  STATUS_UNSPECIFIED = 0,
  STATUS_PENDING = 1,
  STATUS_ACTIVE = 2,
  STATUS_CLOSED = 3,
  UNRECOGNIZED = -1,
}
export const StatusAmino = Status;
export function statusFromJSON(object: any): Status {
  switch (object) {
    case 0:
    case "STATUS_UNSPECIFIED":
      return Status.STATUS_UNSPECIFIED;
    case 1:
    case "STATUS_PENDING":
      return Status.STATUS_PENDING;
    case 2:
    case "STATUS_ACTIVE":
      return Status.STATUS_ACTIVE;
    case 3:
    case "STATUS_CLOSED":
      return Status.STATUS_CLOSED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Status.UNRECOGNIZED;
  }
}
export function statusToJSON(object: Status): string {
  switch (object) {
    case Status.STATUS_UNSPECIFIED:
      return "STATUS_UNSPECIFIED";
    case Status.STATUS_PENDING:
      return "STATUS_PENDING";
    case Status.STATUS_ACTIVE:
      return "STATUS_ACTIVE";
    case Status.STATUS_CLOSED:
      return "STATUS_CLOSED";
    case Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** LeaseStatus defines the status of a lease */
export enum LeaseStatus {
  LEASE_STATUS_UNSPECIFIED = 0,
  LEASE_STATUS_ACTIVE = 1,
  LEASE_STATUS_EXPIRED = 2,
  LEASE_STATUS_CANCELLED = 3,
  UNRECOGNIZED = -1,
}
export const LeaseStatusAmino = LeaseStatus;
export function leaseStatusFromJSON(object: any): LeaseStatus {
  switch (object) {
    case 0:
    case "LEASE_STATUS_UNSPECIFIED":
      return LeaseStatus.LEASE_STATUS_UNSPECIFIED;
    case 1:
    case "LEASE_STATUS_ACTIVE":
      return LeaseStatus.LEASE_STATUS_ACTIVE;
    case 2:
    case "LEASE_STATUS_EXPIRED":
      return LeaseStatus.LEASE_STATUS_EXPIRED;
    case 3:
    case "LEASE_STATUS_CANCELLED":
      return LeaseStatus.LEASE_STATUS_CANCELLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LeaseStatus.UNRECOGNIZED;
  }
}
export function leaseStatusToJSON(object: LeaseStatus): string {
  switch (object) {
    case LeaseStatus.LEASE_STATUS_UNSPECIFIED:
      return "LEASE_STATUS_UNSPECIFIED";
    case LeaseStatus.LEASE_STATUS_ACTIVE:
      return "LEASE_STATUS_ACTIVE";
    case LeaseStatus.LEASE_STATUS_EXPIRED:
      return "LEASE_STATUS_EXPIRED";
    case LeaseStatus.LEASE_STATUS_CANCELLED:
      return "LEASE_STATUS_CANCELLED";
    case LeaseStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
/** Info defines the Info of the medianode */
export interface Info {
  moniker: string;
  description: string;
  contact: string;
}
export interface InfoProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.Info";
  value: Uint8Array;
}
/** Info defines the Info of the medianode */
export interface InfoAmino {
  moniker?: string;
  description?: string;
  contact?: string;
}
export interface InfoAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.Info";
  value: InfoAmino;
}
/** HardwareSpecs defines the hardware specifications of a media node */
export interface HardwareSpecs {
  /** Number of CPUs */
  cpus: bigint;
  /** RAM in GB */
  ramInGb: bigint;
  /** Storage in GB */
  storageInGb: bigint;
}
export interface HardwareSpecsProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.HardwareSpecs";
  value: Uint8Array;
}
/** HardwareSpecs defines the hardware specifications of a media node */
export interface HardwareSpecsAmino {
  /** Number of CPUs */
  cpus: string;
  /** RAM in GB */
  ram_in_gb: string;
  /** Storage in GB */
  storage_in_gb: string;
}
export interface HardwareSpecsAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.HardwareSpecs";
  value: HardwareSpecsAmino;
}
/** Deposit defines the structure for a deposit made to a media node */
export interface Deposit {
  /** Amount deposited */
  amount: Coin;
  /** Address of the depositor */
  depositor: string;
  /** Timestamp of the deposit */
  depositedAt: Timestamp;
}
export interface DepositProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.Deposit";
  value: Uint8Array;
}
/** Deposit defines the structure for a deposit made to a media node */
export interface DepositAmino {
  /** Amount deposited */
  amount?: CoinAmino;
  /** Address of the depositor */
  depositor?: string;
  /** Timestamp of the deposit */
  deposited_at?: string;
}
export interface DepositAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.Deposit";
  value: DepositAmino;
}
/** MediaNode defines the structure for a media node */
export interface MediaNode {
  id: string;
  url: string;
  hardwareSpecs: HardwareSpecs;
  owner: string;
  pricePerHour: Coin;
  status: Status;
  leased: boolean;
  registeredAt: Timestamp;
  deposits: Deposit[];
  closedAt: Timestamp;
  info: Info;
}
export interface MediaNodeProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.MediaNode";
  value: Uint8Array;
}
/** MediaNode defines the structure for a media node */
export interface MediaNodeAmino {
  id?: string;
  url?: string;
  hardware_specs?: HardwareSpecsAmino;
  owner?: string;
  price_per_hour?: CoinAmino;
  status?: Status;
  leased?: boolean;
  registered_at?: string;
  deposits?: DepositAmino[];
  closed_at?: string;
  info?: InfoAmino;
}
export interface MediaNodeAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.MediaNode";
  value: MediaNodeAmino;
}
/** Lease defines the structure for a media node lease */
export interface Lease {
  mediaNodeId: string;
  owner: string;
  lessee: string;
  pricePerHour: Coin;
  totalLeaseAmount: Coin;
  settledLeaseAmount: Coin;
  startTime: Timestamp;
  leasedHours: bigint;
  lastSettledAt: Timestamp;
}
export interface LeaseProtoMsg {
  typeUrl: "/OmniFlix.medianode.v1beta1.Lease";
  value: Uint8Array;
}
/** Lease defines the structure for a media node lease */
export interface LeaseAmino {
  media_node_id?: string;
  owner?: string;
  lessee?: string;
  price_per_hour?: CoinAmino;
  total_lease_amount?: CoinAmino;
  settled_lease_amount?: CoinAmino;
  start_time?: string;
  leased_hours?: string;
  last_settled_at?: string;
}
export interface LeaseAminoMsg {
  type: "/OmniFlix.medianode.v1beta1.Lease";
  value: LeaseAmino;
}
function createBaseInfo(): Info {
  return {
    moniker: "",
    description: "",
    contact: ""
  };
}
export const Info = {
  typeUrl: "/OmniFlix.medianode.v1beta1.Info",
  encode(message: Info, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.moniker !== "") {
      writer.uint32(10).string(message.moniker);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    if (message.contact !== "") {
      writer.uint32(26).string(message.contact);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): Info {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.moniker = reader.string();
          break;
        case 2:
          message.description = reader.string();
          break;
        case 3:
          message.contact = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<Info>, I>>(object: I): Info {
    const message = createBaseInfo();
    message.moniker = object.moniker ?? "";
    message.description = object.description ?? "";
    message.contact = object.contact ?? "";
    return message;
  },
  fromAmino(object: InfoAmino): Info {
    const message = createBaseInfo();
    if (object.moniker !== undefined && object.moniker !== null) {
      message.moniker = object.moniker;
    }
    if (object.description !== undefined && object.description !== null) {
      message.description = object.description;
    }
    if (object.contact !== undefined && object.contact !== null) {
      message.contact = object.contact;
    }
    return message;
  },
  toAmino(message: Info): InfoAmino {
    const obj: any = {};
    obj.moniker = message.moniker === "" ? undefined : message.moniker;
    obj.description = message.description === "" ? undefined : message.description;
    obj.contact = message.contact === "" ? undefined : message.contact;
    return obj;
  },
  fromAminoMsg(object: InfoAminoMsg): Info {
    return Info.fromAmino(object.value);
  },
  fromProtoMsg(message: InfoProtoMsg): Info {
    return Info.decode(message.value);
  },
  toProto(message: Info): Uint8Array {
    return Info.encode(message).finish();
  },
  toProtoMsg(message: Info): InfoProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.Info",
      value: Info.encode(message).finish()
    };
  }
};
function createBaseHardwareSpecs(): HardwareSpecs {
  return {
    cpus: BigInt(0),
    ramInGb: BigInt(0),
    storageInGb: BigInt(0)
  };
}
export const HardwareSpecs = {
  typeUrl: "/OmniFlix.medianode.v1beta1.HardwareSpecs",
  encode(message: HardwareSpecs, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.cpus !== BigInt(0)) {
      writer.uint32(8).int64(message.cpus);
    }
    if (message.ramInGb !== BigInt(0)) {
      writer.uint32(16).int64(message.ramInGb);
    }
    if (message.storageInGb !== BigInt(0)) {
      writer.uint32(24).int64(message.storageInGb);
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): HardwareSpecs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHardwareSpecs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.cpus = reader.int64();
          break;
        case 2:
          message.ramInGb = reader.int64();
          break;
        case 3:
          message.storageInGb = reader.int64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<HardwareSpecs>, I>>(object: I): HardwareSpecs {
    const message = createBaseHardwareSpecs();
    if (object.cpus !== undefined && object.cpus !== null) {
      message.cpus = BigInt(object.cpus.toString());
    }
    if (object.ramInGb !== undefined && object.ramInGb !== null) {
      message.ramInGb = BigInt(object.ramInGb.toString());
    }
    if (object.storageInGb !== undefined && object.storageInGb !== null) {
      message.storageInGb = BigInt(object.storageInGb.toString());
    }
    return message;
  },
  fromAmino(object: HardwareSpecsAmino): HardwareSpecs {
    const message = createBaseHardwareSpecs();
    if (object.cpus !== undefined && object.cpus !== null) {
      message.cpus = BigInt(object.cpus);
    }
    if (object.ram_in_gb !== undefined && object.ram_in_gb !== null) {
      message.ramInGb = BigInt(object.ram_in_gb);
    }
    if (object.storage_in_gb !== undefined && object.storage_in_gb !== null) {
      message.storageInGb = BigInt(object.storage_in_gb);
    }
    return message;
  },
  toAmino(message: HardwareSpecs): HardwareSpecsAmino {
    const obj: any = {};
    obj.cpus = message.cpus ? message.cpus?.toString() : "0";
    obj.ram_in_gb = message.ramInGb ? message.ramInGb?.toString() : "0";
    obj.storage_in_gb = message.storageInGb ? message.storageInGb?.toString() : "0";
    return obj;
  },
  fromAminoMsg(object: HardwareSpecsAminoMsg): HardwareSpecs {
    return HardwareSpecs.fromAmino(object.value);
  },
  fromProtoMsg(message: HardwareSpecsProtoMsg): HardwareSpecs {
    return HardwareSpecs.decode(message.value);
  },
  toProto(message: HardwareSpecs): Uint8Array {
    return HardwareSpecs.encode(message).finish();
  },
  toProtoMsg(message: HardwareSpecs): HardwareSpecsProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.HardwareSpecs",
      value: HardwareSpecs.encode(message).finish()
    };
  }
};
function createBaseDeposit(): Deposit {
  return {
    amount: Coin.fromPartial({}),
    depositor: "",
    depositedAt: Timestamp.fromPartial({})
  };
}
export const Deposit = {
  typeUrl: "/OmniFlix.medianode.v1beta1.Deposit",
  encode(message: Deposit, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.amount !== undefined) {
      Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
    }
    if (message.depositor !== "") {
      writer.uint32(18).string(message.depositor);
    }
    if (message.depositedAt !== undefined) {
      Timestamp.encode(message.depositedAt, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): Deposit {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeposit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.amount = Coin.decode(reader, reader.uint32());
          break;
        case 2:
          message.depositor = reader.string();
          break;
        case 3:
          message.depositedAt = Timestamp.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<Deposit>, I>>(object: I): Deposit {
    const message = createBaseDeposit();
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromPartial(object.amount);
    }
    message.depositor = object.depositor ?? "";
    if (object.depositedAt !== undefined && object.depositedAt !== null) {
      message.depositedAt = Timestamp.fromPartial(object.depositedAt);
    }
    return message;
  },
  fromAmino(object: DepositAmino): Deposit {
    const message = createBaseDeposit();
    if (object.amount !== undefined && object.amount !== null) {
      message.amount = Coin.fromAmino(object.amount);
    }
    if (object.depositor !== undefined && object.depositor !== null) {
      message.depositor = object.depositor;
    }
    if (object.deposited_at !== undefined && object.deposited_at !== null) {
      message.depositedAt = Timestamp.fromAmino(object.deposited_at);
    }
    return message;
  },
  toAmino(message: Deposit): DepositAmino {
    const obj: any = {};
    obj.amount = message.amount ? Coin.toAmino(message.amount) : undefined;
    obj.depositor = message.depositor === "" ? undefined : message.depositor;
    obj.deposited_at = message.depositedAt ? Timestamp.toAmino(message.depositedAt) : undefined;
    return obj;
  },
  fromAminoMsg(object: DepositAminoMsg): Deposit {
    return Deposit.fromAmino(object.value);
  },
  fromProtoMsg(message: DepositProtoMsg): Deposit {
    return Deposit.decode(message.value);
  },
  toProto(message: Deposit): Uint8Array {
    return Deposit.encode(message).finish();
  },
  toProtoMsg(message: Deposit): DepositProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.Deposit",
      value: Deposit.encode(message).finish()
    };
  }
};
function createBaseMediaNode(): MediaNode {
  return {
    id: "",
    url: "",
    hardwareSpecs: HardwareSpecs.fromPartial({}),
    owner: "",
    pricePerHour: Coin.fromPartial({}),
    status: 0,
    leased: false,
    registeredAt: Timestamp.fromPartial({}),
    deposits: [],
    closedAt: Timestamp.fromPartial({}),
    info: Info.fromPartial({})
  };
}
export const MediaNode = {
  typeUrl: "/OmniFlix.medianode.v1beta1.MediaNode",
  encode(message: MediaNode, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.hardwareSpecs !== undefined) {
      HardwareSpecs.encode(message.hardwareSpecs, writer.uint32(26).fork()).ldelim();
    }
    if (message.owner !== "") {
      writer.uint32(34).string(message.owner);
    }
    if (message.pricePerHour !== undefined) {
      Coin.encode(message.pricePerHour, writer.uint32(42).fork()).ldelim();
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (message.leased === true) {
      writer.uint32(56).bool(message.leased);
    }
    if (message.registeredAt !== undefined) {
      Timestamp.encode(message.registeredAt, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.deposits) {
      Deposit.encode(v!, writer.uint32(74).fork()).ldelim();
    }
    if (message.closedAt !== undefined) {
      Timestamp.encode(message.closedAt, writer.uint32(82).fork()).ldelim();
    }
    if (message.info !== undefined) {
      Info.encode(message.info, writer.uint32(90).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MediaNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMediaNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.url = reader.string();
          break;
        case 3:
          message.hardwareSpecs = HardwareSpecs.decode(reader, reader.uint32());
          break;
        case 4:
          message.owner = reader.string();
          break;
        case 5:
          message.pricePerHour = Coin.decode(reader, reader.uint32());
          break;
        case 6:
          message.status = reader.int32() as any;
          break;
        case 7:
          message.leased = reader.bool();
          break;
        case 8:
          message.registeredAt = Timestamp.decode(reader, reader.uint32());
          break;
        case 9:
          message.deposits.push(Deposit.decode(reader, reader.uint32()));
          break;
        case 10:
          message.closedAt = Timestamp.decode(reader, reader.uint32());
          break;
        case 11:
          message.info = Info.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<MediaNode>, I>>(object: I): MediaNode {
    const message = createBaseMediaNode();
    message.id = object.id ?? "";
    message.url = object.url ?? "";
    if (object.hardwareSpecs !== undefined && object.hardwareSpecs !== null) {
      message.hardwareSpecs = HardwareSpecs.fromPartial(object.hardwareSpecs);
    }
    message.owner = object.owner ?? "";
    if (object.pricePerHour !== undefined && object.pricePerHour !== null) {
      message.pricePerHour = Coin.fromPartial(object.pricePerHour);
    }
    message.status = object.status ?? 0;
    message.leased = object.leased ?? false;
    if (object.registeredAt !== undefined && object.registeredAt !== null) {
      message.registeredAt = Timestamp.fromPartial(object.registeredAt);
    }
    message.deposits = object.deposits?.map(e => Deposit.fromPartial(e)) || [];
    if (object.closedAt !== undefined && object.closedAt !== null) {
      message.closedAt = Timestamp.fromPartial(object.closedAt);
    }
    if (object.info !== undefined && object.info !== null) {
      message.info = Info.fromPartial(object.info);
    }
    return message;
  },
  fromAmino(object: MediaNodeAmino): MediaNode {
    const message = createBaseMediaNode();
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    }
    if (object.url !== undefined && object.url !== null) {
      message.url = object.url;
    }
    if (object.hardware_specs !== undefined && object.hardware_specs !== null) {
      message.hardwareSpecs = HardwareSpecs.fromAmino(object.hardware_specs);
    }
    if (object.owner !== undefined && object.owner !== null) {
      message.owner = object.owner;
    }
    if (object.price_per_hour !== undefined && object.price_per_hour !== null) {
      message.pricePerHour = Coin.fromAmino(object.price_per_hour);
    }
    if (object.status !== undefined && object.status !== null) {
      message.status = object.status;
    }
    if (object.leased !== undefined && object.leased !== null) {
      message.leased = object.leased;
    }
    if (object.registered_at !== undefined && object.registered_at !== null) {
      message.registeredAt = Timestamp.fromAmino(object.registered_at);
    }
    message.deposits = object.deposits?.map(e => Deposit.fromAmino(e)) || [];
    if (object.closed_at !== undefined && object.closed_at !== null) {
      message.closedAt = Timestamp.fromAmino(object.closed_at);
    }
    if (object.info !== undefined && object.info !== null) {
      message.info = Info.fromAmino(object.info);
    }
    return message;
  },
  toAmino(message: MediaNode): MediaNodeAmino {
    const obj: any = {};
    obj.id = message.id === "" ? undefined : message.id;
    obj.url = message.url === "" ? undefined : message.url;
    obj.hardware_specs = message.hardwareSpecs ? HardwareSpecs.toAmino(message.hardwareSpecs) : undefined;
    obj.owner = message.owner === "" ? undefined : message.owner;
    obj.price_per_hour = message.pricePerHour ? Coin.toAmino(message.pricePerHour) : undefined;
    obj.status = message.status === 0 ? undefined : message.status;
    obj.leased = message.leased === false ? undefined : message.leased;
    obj.registered_at = message.registeredAt ? Timestamp.toAmino(message.registeredAt) : undefined;
    if (message.deposits) {
      obj.deposits = message.deposits.map(e => e ? Deposit.toAmino(e) : undefined);
    } else {
      obj.deposits = message.deposits;
    }
    obj.closed_at = message.closedAt ? Timestamp.toAmino(message.closedAt) : undefined;
    obj.info = message.info ? Info.toAmino(message.info) : undefined;
    return obj;
  },
  fromAminoMsg(object: MediaNodeAminoMsg): MediaNode {
    return MediaNode.fromAmino(object.value);
  },
  fromProtoMsg(message: MediaNodeProtoMsg): MediaNode {
    return MediaNode.decode(message.value);
  },
  toProto(message: MediaNode): Uint8Array {
    return MediaNode.encode(message).finish();
  },
  toProtoMsg(message: MediaNode): MediaNodeProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.MediaNode",
      value: MediaNode.encode(message).finish()
    };
  }
};
function createBaseLease(): Lease {
  return {
    mediaNodeId: "",
    owner: "",
    lessee: "",
    pricePerHour: Coin.fromPartial({}),
    totalLeaseAmount: Coin.fromPartial({}),
    settledLeaseAmount: Coin.fromPartial({}),
    startTime: Timestamp.fromPartial({}),
    leasedHours: BigInt(0),
    lastSettledAt: Timestamp.fromPartial({})
  };
}
export const Lease = {
  typeUrl: "/OmniFlix.medianode.v1beta1.Lease",
  encode(message: Lease, writer: BinaryWriter = BinaryWriter.create()): BinaryWriter {
    if (message.mediaNodeId !== "") {
      writer.uint32(10).string(message.mediaNodeId);
    }
    if (message.owner !== "") {
      writer.uint32(18).string(message.owner);
    }
    if (message.lessee !== "") {
      writer.uint32(26).string(message.lessee);
    }
    if (message.pricePerHour !== undefined) {
      Coin.encode(message.pricePerHour, writer.uint32(34).fork()).ldelim();
    }
    if (message.totalLeaseAmount !== undefined) {
      Coin.encode(message.totalLeaseAmount, writer.uint32(42).fork()).ldelim();
    }
    if (message.settledLeaseAmount !== undefined) {
      Coin.encode(message.settledLeaseAmount, writer.uint32(50).fork()).ldelim();
    }
    if (message.startTime !== undefined) {
      Timestamp.encode(message.startTime, writer.uint32(58).fork()).ldelim();
    }
    if (message.leasedHours !== BigInt(0)) {
      writer.uint32(64).uint64(message.leasedHours);
    }
    if (message.lastSettledAt !== undefined) {
      Timestamp.encode(message.lastSettledAt, writer.uint32(74).fork()).ldelim();
    }
    return writer;
  },
  decode(input: BinaryReader | Uint8Array, length?: number): Lease {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLease();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mediaNodeId = reader.string();
          break;
        case 2:
          message.owner = reader.string();
          break;
        case 3:
          message.lessee = reader.string();
          break;
        case 4:
          message.pricePerHour = Coin.decode(reader, reader.uint32());
          break;
        case 5:
          message.totalLeaseAmount = Coin.decode(reader, reader.uint32());
          break;
        case 6:
          message.settledLeaseAmount = Coin.decode(reader, reader.uint32());
          break;
        case 7:
          message.startTime = Timestamp.decode(reader, reader.uint32());
          break;
        case 8:
          message.leasedHours = reader.uint64();
          break;
        case 9:
          message.lastSettledAt = Timestamp.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial<I extends Exact<DeepPartial<Lease>, I>>(object: I): Lease {
    const message = createBaseLease();
    message.mediaNodeId = object.mediaNodeId ?? "";
    message.owner = object.owner ?? "";
    message.lessee = object.lessee ?? "";
    if (object.pricePerHour !== undefined && object.pricePerHour !== null) {
      message.pricePerHour = Coin.fromPartial(object.pricePerHour);
    }
    if (object.totalLeaseAmount !== undefined && object.totalLeaseAmount !== null) {
      message.totalLeaseAmount = Coin.fromPartial(object.totalLeaseAmount);
    }
    if (object.settledLeaseAmount !== undefined && object.settledLeaseAmount !== null) {
      message.settledLeaseAmount = Coin.fromPartial(object.settledLeaseAmount);
    }
    if (object.startTime !== undefined && object.startTime !== null) {
      message.startTime = Timestamp.fromPartial(object.startTime);
    }
    if (object.leasedHours !== undefined && object.leasedHours !== null) {
      message.leasedHours = BigInt(object.leasedHours.toString());
    }
    if (object.lastSettledAt !== undefined && object.lastSettledAt !== null) {
      message.lastSettledAt = Timestamp.fromPartial(object.lastSettledAt);
    }
    return message;
  },
  fromAmino(object: LeaseAmino): Lease {
    const message = createBaseLease();
    if (object.media_node_id !== undefined && object.media_node_id !== null) {
      message.mediaNodeId = object.media_node_id;
    }
    if (object.owner !== undefined && object.owner !== null) {
      message.owner = object.owner;
    }
    if (object.lessee !== undefined && object.lessee !== null) {
      message.lessee = object.lessee;
    }
    if (object.price_per_hour !== undefined && object.price_per_hour !== null) {
      message.pricePerHour = Coin.fromAmino(object.price_per_hour);
    }
    if (object.total_lease_amount !== undefined && object.total_lease_amount !== null) {
      message.totalLeaseAmount = Coin.fromAmino(object.total_lease_amount);
    }
    if (object.settled_lease_amount !== undefined && object.settled_lease_amount !== null) {
      message.settledLeaseAmount = Coin.fromAmino(object.settled_lease_amount);
    }
    if (object.start_time !== undefined && object.start_time !== null) {
      message.startTime = Timestamp.fromAmino(object.start_time);
    }
    if (object.leased_hours !== undefined && object.leased_hours !== null) {
      message.leasedHours = BigInt(object.leased_hours);
    }
    if (object.last_settled_at !== undefined && object.last_settled_at !== null) {
      message.lastSettledAt = Timestamp.fromAmino(object.last_settled_at);
    }
    return message;
  },
  toAmino(message: Lease): LeaseAmino {
    const obj: any = {};
    obj.media_node_id = message.mediaNodeId === "" ? undefined : message.mediaNodeId;
    obj.owner = message.owner === "" ? undefined : message.owner;
    obj.lessee = message.lessee === "" ? undefined : message.lessee;
    obj.price_per_hour = message.pricePerHour ? Coin.toAmino(message.pricePerHour) : undefined;
    obj.total_lease_amount = message.totalLeaseAmount ? Coin.toAmino(message.totalLeaseAmount) : undefined;
    obj.settled_lease_amount = message.settledLeaseAmount ? Coin.toAmino(message.settledLeaseAmount) : undefined;
    obj.start_time = message.startTime ? Timestamp.toAmino(message.startTime) : undefined;
    obj.leased_hours = message.leasedHours !== BigInt(0) ? message.leasedHours?.toString() : undefined;
    obj.last_settled_at = message.lastSettledAt ? Timestamp.toAmino(message.lastSettledAt) : undefined;
    return obj;
  },
  fromAminoMsg(object: LeaseAminoMsg): Lease {
    return Lease.fromAmino(object.value);
  },
  fromProtoMsg(message: LeaseProtoMsg): Lease {
    return Lease.decode(message.value);
  },
  toProto(message: Lease): Uint8Array {
    return Lease.encode(message).finish();
  },
  toProtoMsg(message: Lease): LeaseProtoMsg {
    return {
      typeUrl: "/OmniFlix.medianode.v1beta1.Lease",
      value: Lease.encode(message).finish()
    };
  }
};